import { create } from 'zustand';
import type { SettingsTarget } from '../utils/notificationFeed';

/**
 * One-shot deep links INTO Settings — a notification opens a section (and a
 * support ticket) there.
 *
 * ⚠️ An in-memory store, not a localStorage flag read on mount: when Settings is
 * ALREADY the open page, nothing remounts, so a mount-time read would miss the
 * second click. SettingsView and SupportSettings subscribe and consume.
 */
interface SettingsDeepLinkState {
  /** Section to open; SettingsView consumes it. */
  target: SettingsTarget | null;
  /** Support ticket to expand; SupportSettings' thread consumes it. */
  ticketId: string | null;
  open: (target: SettingsTarget, ticketId?: string | null) => void;
  consumeTarget: () => void;
  consumeTicket: () => void;
}

export const useSettingsDeepLink = create<SettingsDeepLinkState>()((set) => ({
  target: null,
  ticketId: null,
  open: (target, ticketId = null) => set({ target, ticketId }),
  consumeTarget: () => set({ target: null }),
  consumeTicket: () => set({ ticketId: null }),
}));
